/**
 * ERC Unconnected Wire Endpoint Validator Adapter for DRC System
 *
 * This validator checks for wire endpoints that are not connected to any pin or other wire.
 *
 * Note: This validator requires schematic route data which is not currently
 * available in IDrcInputs. Returns empty results until route data is added.
 *
 * Feature-gated via DrcEnabledCheckers.ErcUnconnectedWireEndpointValidator
 */
import { ReviewType } from "@buildwithflux/models";
import { getProblemTypeKeyFromReviewType } from "../../drc/types";
/**
 * Validator that checks for unconnected wire endpoints.
 */
export class ErcUnconnectedWireEndpointValidator {
    reviewType = ReviewType.DesignRuleCheckErcUnconnectedWireEndpoint;
    problemTypeKey = getProblemTypeKeyFromReviewType(this.reviewType);
    defaultHidden = true;
    async checkForProblems(_inputs) {
        const foundProblems = [];
        // Note: This validator requires schematic route data which is not currently
        // available in IDrcInputs. Returns empty results until route data is added.
        return {
            error: false,
            problemTypeKey: this.problemTypeKey,
            foundProblems,
        };
    }
}
//# sourceMappingURL=ErcUnconnectedWireEndpointValidator.js.map